module.exports = __webpack_public_path__ + "img/img_signup.a0233b81.png";